module.exports = __webpack_public_path__ + "static/media/Notifications.8a376b2a.svg";